export class Mounths {
  static List: any[] = [
    { id: 0, name: 'Janvier', code: '01' },
    { id: 1, name: 'Fevrier', code: '02' },
    { id: 2, name: 'Mars', code: '03' },
    { id: 3, name: 'Avril', code: '04' },
    { id: 4, name: 'Mai', code: '05' },
    { id: 5, name: 'Juin', code: '06' },
    { id: 6, name: 'Juillet', code: '07' },
    { id: 7, name: 'Août', code: '08' },
    { id: 8, name: 'Septembre', code: '09' },
    { id: 9, name: 'Octobre', code: '10' },
    { id: 10, name: 'Novembre', code: '11' },
    { id: 11, name: 'Décembre', code: '12' },
  ];

  // Méthode pour trouver un mois par son code
  static findByCode(code: string): any | undefined {
    return this.List.find((month) => month.code === code);
  }
}
